import { get } from 'lodash';
import { VariableId } from './types';
import { useSelector } from './utils';

export type VisibilityProps = {
  visibility?:
    | {
        variableId: VariableId;
      }
    | {
        variableIds: (
          | { variableId: VariableId; reversed: boolean }
          | { variableId: VariableId }
          | VariableId
        )[];
      }
    | Record<string, never>;
};

export const useVisibility = (options: VisibilityProps['visibility'] = {}) => {
  const visibilityValue = useSelector(({ variables }) => {
    const variableIds = (
      'variableId' in options
        ? [options.variableId]
        : 'variableIds' in options
        ? options.variableIds
        : []
    ).map((v) =>
      typeof v === 'string'
        ? { variableId: v, reversed: false }
        : { reversed: false, ...v }
    );

    if (!variableIds.length) return undefined;

    return variableIds.reduce((acc, { variableId, reversed }) => {
      const value = Boolean(get(variables, variableId));

      return acc && (reversed ? !value : value);
    }, true);
  });

  if (typeof visibilityValue === 'undefined') return true;

  return Boolean(visibilityValue);
};
